import { adminHttpClient } from '../commons/adminHttpClient'

const wizardApi = (): Promise<any> => {
  return adminHttpClient.get('/NonEESignup/Wizard').then((response: any) => {
    console.log('Response ' + response)
    return response.steps
  })
}

export default wizardApi
